import { ProductLineItem } from '@time-line/components/common';
import { FormatPrice } from 'components/localisation/FormatPrice';
import { BundleAccordionItem } from 'components/product/BundleAccordionItem';
import { useSanityProduct } from 'hooks/product/useSanityProduct';
import { useLocalStorage, UserLocale } from 'hooks/userPreferences';
import { DEFAULT_TITLE } from 'lib/constants/products';
import type { CartLineItem } from 'types/cart/CartLineItem';
import { resolveProductInfo } from 'utils/product/resolveProductInfo';

interface BundleLineItemProps {
  line: CartLineItem;
  index: number;
  isLast?: boolean;
}

export function BundleLineItem({ line, index, isLast }: BundleLineItemProps) {
  const { merchandise, cost } = line;
  const {
    value: { countryCode, currencyCode },
  } = useLocalStorage(UserLocale);
  const sanityProduct = useSanityProduct(merchandise.product.handle);

  const { title, subtitle: subTitle } = sanityProduct
    ? resolveProductInfo({ sanityProduct })
    : {
        title: merchandise.product.title,
        subtitle:
          merchandise.title === DEFAULT_TITLE ? undefined : merchandise.title,
      };

  const isFree = cost.totalAmount.amount === 0;

  return (
    <BundleAccordionItem
      product={sanityProduct ?? undefined}
      dividerProps={{ addOpacity: true }}
      isLast={isLast}
      header={
        <>
          <ProductLineItem
            className={`product-line-item-${index + 1}`}
            flex={1}
            py={0}
            showPrice={false}
            colorScheme="gray"
            title={title}
            subTitle={subTitle}
            image={merchandise.image?.url}
            price={cost.totalAmount.amount}
            countryCode={countryCode}
            currencyCode={currencyCode}
            availableForSale={merchandise.availableForSale}
          />
          {isFree && (
            <FormatPrice
              amount={0}
              showFreeIfZero
              color="red.300"
              size="title2"
              fontWeight="medium"
              textTransform="uppercase"
              mr="4xs"
            />
          )}
        </>
      }
    />
  );
}
